import request from '@/utils/request.js'

// 批量修改设备参数
export const batchSetNormalTemp = (data) => {
    return request({
        url: '/heating/device/setting/calibration',
        method: 'POST',
        data
    })
}
